module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"components":{"start":{"fund_search":{"description":"Find suitable funds based on your criteria.","search":{"button":"Start fund search","placeholder":"WKN, ISIN or Name"},"title":"Fund search"}}}}}}')
  delete Component.options._Ctor
}
